import { Component, OnDestroy, OnInit, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { BsModalService } from "ngx-bootstrap/modal";
import * as moment from "moment";
import { StaticStampService } from "../../../../common/services/StaticStamp.service";
import * as _ from "lodash";
import { environment } from "../../../../../environments/environment";

declare var $: any;

@Component({
  selector: "static-history",
  templateUrl: "./static_report.component.html",
  styleUrls: ["./static_report.component.css"],
  providers: [StaticStampService, BsModalService],
})
export class StaticReportComponent implements OnInit {
  public model: any = {};
  public stamp_id: number;
  public FormFilter: FormGroup;
  public currentPage: number = 1;
  public page_size: number = 10;
  public totalRow: number = 0;
  public list: any = [];
  public stamps: any = [];

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private staticService: StaticStampService
  ) {}

  ngOnInit() {
    $("#source").select2({
      placeholder: "Nguồn tương tác",
      allowClear: false,
      containerCss: { height: 32, "margin-right": 5 },
    });
    $("#stamp_ids").select2({
      placeholder: "Chọn tem",
      allowClear: false,
      tags: true,
      multiple: true,
      width: "200px",
      containerCss: {
        width: "200px",
        height: "32px",
        "min-height": "32px",
        "overflow-x": "hidden",
        "margin-right": 5,
      },
    });
    this.loadStamp();
    this.createFormFilter();
    this.loadData();
  }

  loadStamp() {
    this.staticService
      .allStamp()
      .toPromise()
      .then((res: any) => {
        if (res.error === false) {
          this.stamps = res.data;
        } else this.stamps = [];
      });
  }

  loadData(data: any = null) {
    let options: any = {};
    if (this.currentPage < 0) {
      this.currentPage = 1;
    }
    options.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    options.limit = this.page_size;

    if (data && data.range_date) {
      options.from = moment(data.range_date[0]).format("YYYY-MM-DD");
      options.to = moment(data.range_date[1]).format("YYYY-MM-DD");
    }
    if (data && data.source) options.source = data.source;

    if (data && data.stamp_ids && data.stamp_ids.length > 0)
      options.stamp_ids = data.stamp_ids.join(",");
    console.log(data);
    this.staticService.allHistoryStamp(options).subscribe((res: any) => {
      if (res.error == false) {
        console.log(res);
        this.list = res.data;
      }
    });
  }

  createFormFilter() {
    this.FormFilter = this.fb.group({
      stamp_ids: [null],
      source: null,
      range_date: [null],
    });
  }

  ResetFormSearch() {
    $("#stamp_ids").val("").trigger("change");

    $("#source").val("").trigger("change");
    this.currentPage = 1;
    this.FormFilter.reset();
  }

  search(data: any = {}) {
    let stamp_ids = $("#stamp_ids").val();
    let source = $("#source").val();
    stamp_ids = _.map(stamp_ids, (e) => {
      if (e) return parseInt(e);
    });
    data.stamp_ids = stamp_ids;
    data.source = source;

    this.currentPage = 1;
    this.loadData(data);
  }

  setPage(page: number) {
    if (page < 1) {
      this.currentPage = 1;
      return;
    }

    if (page !== this.currentPage) {
      this.currentPage = page;
      this.loadData();
    }
  }
  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    } else {
      this.setPage(1); //toPage = 1;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/static_report/static_report.component.ts